import { Skeleton } from "@website/ui/skeleton";
import dynamic from "next/dynamic";

export const ReminderEditModalClient = dynamic(
  () =>
    import("./reminder-edit-modal").then(
      ({ ReminderEditModal }) => ReminderEditModal
    ),
  {
    ssr: false,
    loading: () => (
      <div className="flex w-[500px] flex-col gap-4">
        <Skeleton height={48} shape="rectangle" />
        <Skeleton height={48} shape="rectangle" />
        <Skeleton height={48} shape="rectangle" />
        <Skeleton height={48} shape="rectangle" />
      </div>
    )
  }
);
